module.exports = __webpack_public_path__ + "static/leda-homecare-young-adult-care-71cf0fbdb1b57e5c808d6c0367b7eded.png";